
// == Otomatik Google Places Autocomplete Başlatıcı ==
function initializeAddressAutocomplete() {
    const addressInput = document.getElementById("address-autocomplete");
    if (!addressInput || typeof google === 'undefined' || !google.maps || !google.maps.places) {
      setTimeout(initializeAddressAutocomplete, 200);
      return;
    }
  
    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: "tr" },
      fields: ["address_components", "formatted_address", "geometry"]
    });
  
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      handlePlace(place);
    });
  }
  
  // == Siparişe Ürün Ekleme Fonksiyonu ==
  function addCourierProductToCart(address, date, time) {
    console.log("🛒 Sepete ekleniyor:", { address, date, time });
  
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: 45230370488501,
            quantity: 1,
            properties: {
              "Teslimat Adresi": address,
              "Teslimat Tarihi": date,
              "Teslimat Saati": time
            }
          }
        ]
      })
    })
      .then(res => {
        if (!res.ok) {
          console.error("❌ Sepete ekleme hatası:", res.status);
          return res.text().then(text => console.warn("↪️ Hata cevabı:", text));
        }
        return res.json();
      })
      .then(data => {
        if (data) console.log("✅ Kurye ürünü sepete eklendi:", data);
      })
      .catch(err => {
        console.error("🚨 Fetch hatası:", err);
      });
  }
  
  // == Otomatik Sepete Ekleme Kontrolü ==
  function tryAutoAddToCart() {
    const courierOption = document.querySelector('#courier-option');
    if (
      courierOption?.checked &&
      selectedAddress &&
      selectedDate &&
      selectedTime
    ) {
      addCourierProductToCart(selectedAddress, selectedDate, selectedTime);
    } else {
      console.log("⏳ Bilgiler eksik, sepete eklenmedi.");
    }
  }
  
  // == Teslimat Alanı Kontrolü ==
  function toggleCourierSection() {
    const courierOption = document.querySelector('#courier-option');
    const addressContainer = document.getElementById("address-container");
    const deliverySelection = document.getElementById("delivery-selection");
    const addressInput = document.getElementById("address-autocomplete");
    const successBox = document.getElementById("success-box");
    const warningBox = document.getElementById("warning-box");
    const changeAddress = document.getElementById("change-address");
  
    if (courierOption?.checked) {
      addressContainer.style.display = "flex";
      deliverySelection.style.display = "block";
    } else {
      addressContainer.style.display = "none";
      deliverySelection.style.display = "none";
      addressInput.value = "";
      addressInput.classList.remove("input-white");
      addressContainer.classList.remove("address-success", "address-error");
      warningBox.style.display = "none";
      if (successBox) successBox.style.display = "none";
      if (changeAddress) changeAddress.style.display = "none";
      localStorage.removeItem("selectedCourierAddress");
    }
  }
  
  let selectedAddress = "";
  let selectedDate = "";
  let selectedTime = "";
  let district = "";
  let neighborhood = "";
  let city = "";
  
  document.addEventListener("DOMContentLoaded", function () {
    initializeAddressAutocomplete();
    setTimeout(toggleCourierSection, 200);
  
    document.querySelectorAll('input[name="delivery-method"]').forEach(input => {
      input.addEventListener("change", toggleCourierSection);
    });
  
    const addressInput = document.getElementById("address-autocomplete");
    const addressContainer = document.getElementById("address-container");
    const changeAddress = document.getElementById("change-address");
    const warningBox = document.getElementById("warning-box");
    const deliverySelection = document.getElementById("delivery-selection");
    const dateButtons = document.getElementById("date-buttons");
    const calendarInput = document.getElementById("flatpickr-date");
    const deliveryTimeInput = document.getElementById("delivery-time");
    const deliveryTimeDropdown = document.getElementById("delivery-time-dropdown");
    const successBox = document.getElementById("success-box");
  
    const stored = localStorage.getItem("selectedCourierAddress");
    if (stored) {
      addressInput.value = stored;
      selectedAddress = stored;
      addressContainer.classList.add("address-success");
      addressInput.classList.add("input-white");
      changeAddress.style.display = "block";
      deliverySelection.style.display = "block";
      if (successBox) successBox.style.display = "block";
      loadDateOptions();
      loadTimeOptions();
    }
  
    changeAddress.addEventListener("click", () => {
      addressInput.value = "";
      addressInput.style.color = "#333";
      addressInput.style.fontWeight = "500";
      addressInput.classList.remove("input-white");
      addressContainer.classList.remove("address-error", "address-success");
      changeAddress.style.display = "none";
      deliverySelection.style.display = "none";
      warningBox.style.display = "none";
      if (successBox) successBox.style.display = "none";
      localStorage.removeItem("selectedCourierAddress");
    });
  
    window.handlePlace = function(place) {
      district = "";
      neighborhood = "";
      city = "";
      addressContainer.classList.remove("address-success", "address-error");
  
      place.address_components.forEach((component) => {
        const types = component.types;
        if (types.includes("administrative_area_level_1")) city = component.long_name;
        if (types.includes("administrative_area_level_2")) district = component.long_name;
        if (
          (types.includes("sublocality_level_1") ||
           types.includes("neighborhood") ||
           types.includes("sublocality") ||
           types.includes("administrative_area_level_4")) &&
          !neighborhood
        ) {
          neighborhood = component.long_name;
        }
      });
  
      if (!neighborhood && place.formatted_address) {
        const match = place.formatted_address.match(/([^,]*Mahallesi)/i);
        if (match && match[1]) neighborhood = match[1].trim();
      }
  
      if (city !== "İstanbul") {
        showWarning("Sadece İstanbul adreslerine kurye ile teslimat yapılır.");
        return;
      }
  
      if (excludedDistricts.map(d => d.trim()).includes(district)) {
        showWarning("Seçtiğiniz ilçe için kurye hizmetimiz yok.");
        return;
      }
  
      if (isNeighborhoodExcluded(district, neighborhood, excludedNeighborhoods)) {
        showWarning("Seçtiğiniz mahalleye kurye hizmetimiz yok.");
        return;
      }
  
      addressContainer.classList.add("address-success");
      addressInput.classList.add("input-white");
      addressInput.style.fontWeight = "bold";
      warningBox.style.display = "none";
      deliverySelection.style.display = "block";
      if (successBox) successBox.style.display = "block";
  
      selectedAddress = place.formatted_address;
      addressInput.value = selectedAddress;
      localStorage.setItem("selectedCourierAddress", selectedAddress);
      changeAddress.style.display = "block";
      loadDateOptions();
      loadTimeOptions();
      tryAutoAddToCart(); // ✅ buraya eklendi
    };
  
    function showWarning(msg) {
      warningBox.textContent = msg;
      warningBox.style.display = "block";
      addressInput.classList.remove("input-white");
      addressInput.style.color = "#000";
      addressInput.style.fontWeight = "bold";
      deliverySelection.style.display = "none";
      if (successBox) successBox.style.display = "none";
      changeAddress.style.display = "block";
      localStorage.removeItem("selectedCourierAddress");
      addressContainer.classList.remove("address-success");
      addressContainer.classList.add("address-error");
    }
  
    function normalize(str) {
      return str?.toLowerCase().replace(" mahallesi", "").trim();
    }
  
    function isNeighborhoodExcluded(district, neighborhood, excludedNeighborhoods) {
      const normNeighborhood = normalize(neighborhood);
      const normDistrict = normalize(district);
      for (const line of excludedNeighborhoods) {
        const [lineDistrict, neighborhoods] = line.split(':');
        if (normalize(lineDistrict) === normDistrict) {
          const arr = (neighborhoods || '').split(',').map(x => normalize(x));
          if (arr.includes(normNeighborhood)) return true;
        }
      }
      return false;
    }
  
    function loadDateOptions() {
      if (!dateButtons) return;
      dateButtons.innerHTML = "";
      let today = new Date();
      const h = today.getHours();
      const m = today.getMinutes();
  
      if (h > 11 || (h === 11 && m >= 45)) {
        today.setDate(today.getDate() + 1);
      }
      today.setHours(0, 0, 0, 0); // ay/ gün hesaplarında kayma olmasın
      
      let count = 0;
      let dayOffset = 0;
  
      while (count < 3) {
        // 'today' baz alınarak başla
        const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        date.setDate(date.getDate() + dayOffset);
  
        // const iso = date.toISOString().split("T")[0]; // BU SATIRI SİL veya YORUMA AL

// YERİNE BUNU YAPIŞTIR:
const year = date.getFullYear();
const month = String(date.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başlar, o yüzden +1
const day = String(date.getDate()).padStart(2, '0');
const iso = `${year}-${month}-${day}`;
        const dayOfWeek = date.getDay();
        const isWeekend = (dayOfWeek === 0); // sadece Pazar


  
        if ((disableWeekends && isWeekend) || excludedDates.includes(iso)) {
          dayOffset++;
          continue;
        }
  
        const dayStr = date.toLocaleDateString("tr-TR", { weekday: "long" });
        const dateStr = date.toLocaleDateString("tr-TR", { day: "2-digit", month: "long" });
  
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "date-option-btn";
        btn.innerHTML = `<span class="date-label">${dateStr}</span><span class="day-label">${dayStr}</span>`;
        btn.addEventListener("click", () => {
          document.querySelectorAll('.date-option-btn').forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");
          selectedDate = iso;
          deliveryTimeDropdown.style.display = "block";
          deliverySelection.style.paddingBottom = "60px";
          tryAutoAddToCart(); // ✅ buraya eklendi
        });
  
        dateButtons.appendChild(btn);
        count++;
        dayOffset++;
      }
  
      const calendarBtn = document.createElement("button");
      calendarBtn.id = "calendar-btn";
      calendarBtn.type = "button";
      calendarBtn.className = "date-option-btn";
      calendarBtn.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0690/1992/6709/files/takvim.png?v=1743853447" alt="Takvim" style="width: 24px; height: 24px; margin-bottom: 4px;">
        <span class="day-label">Takvim</span>
      `;
      calendarBtn.addEventListener("click", () => {
        if (fpInstance) fpInstance.open();
      });
  
      dateButtons.appendChild(calendarBtn);
    }
  
    function loadTimeOptions() {
      if (!deliveryTimeDropdown) return;
      deliveryTimeDropdown.innerHTML = '<option value="">Saat seçiniz</option>';
      deliveryTimeSlots.forEach(time => {
        const option = document.createElement("option");
        option.value = time.trim();
        option.textContent = time.trim();
        deliveryTimeDropdown.appendChild(option);
      });
  
      deliveryTimeDropdown.addEventListener("change", function () {
        selectedTime = this.value;
        deliveryTimeInput.value = this.value;
        tryAutoAddToCart(); // ✅ buraya eklendi
      });
    }
  
  function formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString("tr-TR", { day: "2-digit", month: "long" });
  }
  
  function formatDay(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString("tr-TR", { weekday: "long" });
  }
    
    // Saat 11:45'i geçmişse yarını, değilse bugünü minDate olarak ayarla
    const now = new Date();
    const h = now.getHours();
    const m = now.getMinutes();
    let minDateForCalendar = new Date();
    if (h > 11 || (h === 11 && m >= 45)) {
      minDateForCalendar.setDate(minDateForCalendar.getDate() + 1);
    }
    minDateForCalendar.setHours(0, 0, 0, 0);
    
    const fpInstance = flatpickr("#flatpickr-date", {
    locale: "tr",
    dateFormat: "Y-m-d",
    disable: [
      function (date) {
        const iso = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        const day = date.getDay();
        const isWeekend = (day === 0); // sadece Pazar
        return (disableWeekends && isWeekend) || excludedDates.includes(iso);
      }
    ],
    minDate: minDateForCalendar,
    maxDate: new Date().fp_incr(30), // ✅ maksimum 15 gün sonrası dahil
    appendTo: document.getElementById('date-selection'), // ✅ eklendi
    onChange: function(selectedDates, dateStr) {
    selectedDate = dateStr;
  
    // 1. Tüm .date-option-btn elementlerinden .selected'ı kaldır
    document.querySelectorAll('.date-option-btn').forEach(b => b.classList.remove("selected"));
  
    // 2. Calendar butonunu "seçilmiş" gibi işaretle
    const calendarBtn = document.querySelector("#calendar-btn");
    if (calendarBtn) {
      calendarBtn.classList.add("selected");
  calendarBtn.innerHTML = `
    <span class="date-label">${formatDate(dateStr)}</span>
    <span class="day-label">${formatDay(dateStr)}</span>
  `;
  
    }
  
    // 3. Saat seçimi kutusunu göster
    document.getElementById("delivery-time-dropdown").style.display = "block";
    document.getElementById("delivery-selection").style.paddingBottom = "60px";
  
    // 4. Sepete eklemeyi dene
    tryAutoAddToCart();
  }
  
  });
  
  
  });